/**
 * 排出事業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifests/summaries`

const manifests_summary = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     *
     * @return {Promise<unknown>}
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default manifests_summary
